import { Controller } from "@hotwired/stimulus"

// Keeps recorded UI media aligned with Munibot's saved, class-based theme.
// A source swap preserves playback position when someone toggles while watching.
export default class extends Controller {
  static targets = ["source"]
  static values = {
    lightSrc: String,
    lightPoster: String,
    darkSrc: String,
    darkPoster: String
  }

  connect() {
    this.sync()
  }

  sync(event) {
    const dark = event?.detail?.dark ?? document.documentElement.classList.contains("dark")
    const src = dark && this.hasDarkSrcValue ? this.darkSrcValue : this.lightSrcValue
    const poster = dark && this.hasDarkPosterValue ? this.darkPosterValue : this.lightPosterValue

    if (this.sourceTarget.getAttribute("src") === src && this.element.getAttribute("poster") === poster) return

    const resumeAt = this.element.currentTime || 0
    const shouldResume = !this.element.paused

    if (resumeAt > 0 || shouldResume) {
      this.element.addEventListener("loadedmetadata", () => {
        const duration = Number.isFinite(this.element.duration) ? this.element.duration : resumeAt
        this.element.currentTime = Math.min(resumeAt, duration)
        if (shouldResume) this.element.play().catch(() => {})
      }, { once: true })
    }

    this.element.setAttribute("poster", poster)
    this.sourceTarget.setAttribute("src", src)
    this.element.load()
  }
}
